const validateString = (_string: string, regex: RegExp): boolean => regex.test(_string);

export const containsNumber = (text: string): boolean => {
    const validator = /.*[0-9].*/g;

    return validateString(text, validator);
};

export const containsSpecialCharacter = (text: string): boolean => {
    const validator = /[!@#$%^&(),.?":{}|<>_/*=+\-\\]/g;

    return validateString(text, validator);
};

export const containsUppercaseLetter = (text: string): boolean => {
    const validator = /.*[A-Z].*/g;

    return validateString(text, validator);
};

export const containsLowercaseLetter = (text: string): boolean => {
    const validator = /.*[a-z].*/g;

    return validateString(text, validator);
};
